import React from 'react'
import { getDay, format } from 'date-fns'
import PreferMobile from './PreferMobile'
import HowItWorks from './HowItWorks'
import RestaurantShowcase from './RestaurantShowcase'
import { Action, Spinner } from '@foodsby/nutrient'

const daysOfWeek = [
  'Sunday',
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday',
]

export const UnderSixDays = ({
  activationDate,
  onChangeDay,
  loadingDeliveringRestaurants,
  locationId,
  restaurantLogos,
}) => {
  const SERVING_LOCATION_ON = getDay(activationDate)
  return (
    <div className="row center-xs">
      <div className="col-xs-12 coming-soon-content">
        <h3 className="coming-soon-title">
          Foodsby starts on{' '}
          <Action
            id="coming-soon-day-button"
            onClick={() =>
              onChangeDay(format(activationDate, 'YYYYMMDD'), locationId)
            }
          >
            {daysOfWeek[SERVING_LOCATION_ON]},
          </Action>
          {format(activationDate, ' MMMM Do')}!
        </h3>
        <div className="coming-soon-subtitle">
          See which restaurant options are available and pre-order your first
          lunch now.
        </div>
        <HowItWorks />
        <hr className="coming-soon-hr" />
        <PreferMobile />
        <hr className="coming-soon-hr" />
        {loadingDeliveringRestaurants ? (
          <Spinner className="spinner-lg primary" />
        ) : (
          <RestaurantShowcase restaurantLogos={restaurantLogos} />
        )}
      </div>
    </div>
  )
}

export default UnderSixDays
